module.exports = __webpack_public_path__ + "static/media/Logo Horizontal Blanco transparente.4ef5577c.png";